<template>
  <div
    :class="$style.icon"
  >
    <SystemOSIcon
      data-test-id="CommandTemplateOS__Icon"
      :item="systemItem"
      :showLabel="false"
    />
  </div>
</template>

<script>
import { ItemTableConsts } from 'client/util/Constants';
import SystemOSIcon from 'client/components/ItemTable/BodyComponents/SystemOSIcon.vue';

const { parentOSType } = ItemTableConsts;
const { linux, darwin, windows } = parentOSType;

export default {
  name: 'CommandTemplateOS',

  components: {
    SystemOSIcon,
  },

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  computed: {
    systemItem() {
      if (this.item.type === 'mac') return { osFamily: darwin };

      if (this.item.type === 'windows') return { osFamily: windows };

      return { osFamily: linux };
    },
  },
};
</script>

<style module>
.icon {
  height: 35px;
  width: 35px;
}
</style>
